import axios from "axios";
import tbPCAxiosAdapter from "@qn/services/http/tbAxiosAdapter";
import { ExtendAxiosRequestConfig } from "./types";

export const baseURL = import.meta.env.VITE_MAIN_BASE_URL;

const adapter = import.meta.env.VITE_IS_QN ? tbPCAxiosAdapter : undefined;

/**
 * 由于各电商平台要求将订单等敏感数据存储在各自平台，所以后端分为一个主服务器，和4个平台服务器（淘宝，拼多多，京东，其他），
 * 主服务器存储不敏感的数据，如快递单模板，平台服务器存储各个平台的敏感数据如订单、商品、运单号等，注：小平台对数据存储没要求，所以统一
 * 存储在其他（阿里云）
 */
const mainAxios = axios.create({
    baseURL,
    timeout: 55000,
    adapter,
});

// http post with json body
const post = <T>(urlPath: any, data?: any, config: ExtendAxiosRequestConfig = {}): Promise<T> =>
    mainAxios.post(urlPath, data, config);

// http get
const get = <T>(urlPath: any, params?: any, config: ExtendAxiosRequestConfig = {}): Promise<T> =>
    mainAxios.get(urlPath, { ...config, params });

const mainServerClient = { http: mainAxios, post, get };

export default mainServerClient;
